'use strict';

exports.__esModule = true;
var colors = {
  primaryOrange: '#FFAB00',
  errorRed: '#E2442F',
  errorTint: '#F7D9D7',
  black10: 'rgba(0, 0, 0, 0.10)',
  black20: 'rgba(0, 0, 0, 0.20)',
  black38: 'rgba(0, 0, 0, 0.38)',
  black54: 'rgba(0, 0, 0, 0.54)',
  black87: 'rgba(0, 0, 0, 0.87)',
  white: '#ffffff',
  white10: 'rgba(0, 0, 0, 0.10)',
  white30: 'rgba(255, 255, 255, 0.30)',
  white70: 'rgba(255, 255, 255, 0.70)'
};

exports.default = colors;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/theme/colors.js
// module id = 340
// module chunks = 29